import React from 'react';
import PropTypes from 'prop-types';
import dompurify from 'dompurify';
import { Box } from '../Structure';
import Text from '../Text';
import TextEditor from '../TextEditor';
import ContentThemeStyling from './ContentThemeStyling';


const propTypes = {
  value: PropTypes.string,
  edit: PropTypes.bool,
  inherit: PropTypes.bool,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  onSelectChange: PropTypes.func,
  displayTypeSelect: PropTypes.bool,
  dropDownOptions: PropTypes.arrayOf(PropTypes.object),
  indexOfContentType: PropTypes.number,
};

const defaultProps = {
  edit: false,
  inherit: false,
  onChange: null,
  onSave: null,
  onCancel: null,
  value: null,
  onSelectChange: null,
  displayTypeSelect: false,
  dropDownOptions: null,
  indexOfContentType: null,
};

export default function HtmlContent({
  edit, inherit, onCancel, onChange, onSelectChange, onSave, value,
  displayTypeSelect, dropDownOptions, indexOfContentType,
}) {
  // eslint-disable-next-line react/no-danger
  const htmlRendered = <div dangerouslySetInnerHTML={{ __html: dompurify.sanitize(value) }} />;
  let htmlThemed = htmlRendered;
  if (!inherit) {
    htmlThemed = <ContentThemeStyling>{htmlRendered}</ContentThemeStyling>;
  }

  if (!edit) {
    return htmlThemed;
  }

  return (
    <Box>
      <Text as="h3">Content Source</Text>
      <TextEditor
        onSelectChange={onSelectChange}
        displayTypeSelect={displayTypeSelect}
        indexOfContentType={indexOfContentType}
        onCancel={onCancel}
        onChange={onChange}
        onSave={onSave}
        value={value}
        placeholder="Compose custom content..."
        rows={16}
        dropDownOptions={dropDownOptions}
      />
      <Text as="h3">Content Preview</Text>
      {htmlThemed}
    </Box>
  );
}

HtmlContent.propTypes = propTypes;
HtmlContent.defaultProps = defaultProps;
